'use client'
import {
  createContext,
  ReactNode,
  useEffect,
  useRef,
  useState
} from 'react'

import toast from 'shared/ui/utils/toast'

export interface OfflineContextType {
  isOnline: boolean
  temporaryOfflineNotificationError: () => string
}

export const OfflineContext = createContext<OfflineContextType | undefined>(
  undefined
)

export const OfflineProvider: React.FC<{ children: ReactNode }> = ({
  children
}) => {
  const toastIdRef = useRef<string | undefined>(undefined)
  const [isOnline, setIsOnline] = useState<boolean>(true)

  const temporaryOfflineNotificationError = () =>
    toast.error(
      'Błąd, Aby kontunować proces zakupowy połącz się z siecią internetową.',
      { duration: 2000 }
    )

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(navigator.onLine)
    }

    updateOnlineStatus()

    window.addEventListener('online', updateOnlineStatus)
    window.addEventListener('offline', updateOnlineStatus)

    return () => {
      window.removeEventListener('online', updateOnlineStatus)
      window.removeEventListener('offline', updateOnlineStatus)
      if (toastIdRef.current !== undefined) {
        toast.dismiss(toastIdRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (!isOnline) {
      if (toastIdRef.current === undefined) {
        toastIdRef.current = toast.error('Brak połączenia z internetem', {
          duration: Infinity
        })
      }
    } else {
      if (toastIdRef.current !== undefined) {
        toast.dismiss(toastIdRef.current)
        toastIdRef.current = undefined
      }
    }
  }, [isOnline])

  return (
    <OfflineContext.Provider
      value={{ isOnline, temporaryOfflineNotificationError }}
    >
      {children}
    </OfflineContext.Provider>
  )
}
